import { ref } from "vue";
import { defineStore } from "pinia";
import { getAppName, getAppCaption, getSystemRevision, getLocale } from "@helper/utils.js";

export const useAppStore = defineStore("app", {
    state: () => ({
        appName: getAppName(),
        appCaption: getAppCaption(),
        systemRevision: getSystemRevision(),
        locale: getLocale(),
        permissions: {},
        roles: {},
        superAdminRole: null,
        currentModule: null,
        dataFromSession: null,
        currentDate: null,
        isCreator: false,
        isAdmin: false,
        myId: null,
        timeouts: {
            info: 10,
            error: 15,
        },
    }),
    getters: {
        getAppName: (state) => state.appName,
        getAppCaption: (state) => state.appCaption,
        getSystemRevision: (state) => state.systemRevision,
        getLocale: (state) => state.locale,
        getPermissions: (state) => state.permissions,
        getRoles: (state) => state.roles,
        getSuperAdminRole: (state) => state.superAdminRole,
        getIsCreator: (state) => state.isCreator,
        getIsAdmin: (state) => state.isAdmin,
        getTimeouts: (state) => state.timeouts,
        getMyId: (state) => state.myId,
    },
    actions: {
        setAppName(value) {
            this.appName = value;
        },
        setAppCaption(value) {
            this.appCaption = value;
        },
        setLocale(value) {
            this.locale = value;
        },
    },
});
